import { z } from 'zod';
/**
 * 排序方向枚舉
 */
export const SortDirectionSchema = z.enum(['asc', 'desc']);
/**
 * 分頁資訊 Schema
 * 統一使用 total_pages 格式
 */
export const PaginationSchema = z.object({
    page: z.number().int().positive().describe('當前頁碼'),
    limit: z.number().int().positive().describe('每頁筆數'),
    total: z.number().int().min(0).describe('總筆數'),
    total_pages: z.number().int().min(0).describe('總頁數'),
});
/**
 * 錯誤回應 Schema
 * 統一的錯誤回應格式，符合 ApiError 結構
 */
export const ErrorResponseSchema = z.object({
    code: z.string().describe('錯誤代碼'),
    message: z.string().describe('錯誤訊息'),
    details: z.unknown().optional().describe('錯誤詳情'),
});
/**
 * 台灣手機號碼驗證 Schema
 * 支援可選、可為 null 的格式
 */
export const PhoneNumberSchema = z
    .union([
    z.string().regex(/^09\d{8}$/, '請輸入有效的台灣手機號碼（格式：09XXXXXXXX）'),
    z.literal(''),
    z.null(),
])
    .optional()
    .describe('台灣手機號碼（格式：09XXXXXXXX）');
/**
 * 基礎查詢參數 Schema
 * 包含通用的分頁和排序參數
 */
export const QueryParamsSchema = z.object({
    page: z.coerce.number().int().min(1).default(1).optional().describe('頁碼 (從 1 開始)'),
    limit: z.coerce.number().int().min(1).max(100).default(20).optional().describe('每頁筆數 (1-100)'),
    sortBy: z.string().optional().describe('排序欄位'),
    sortDir: SortDirectionSchema.default('asc').optional().describe('排序方向'),
});
/**
 * 帳號關聯 Schema
 * 用於 Identity Resolution & Account Linking
 */
export const LinkIdentitySchema = z.object({
    primaryProvider: z.literal('google').describe('當前已登入的主要身份提供者'),
    targetProvider: z.literal('line').describe('欲綁定的目標身份提供者'),
    targetIdToken: z.string().describe('目標身份提供者的 ID Token（用於驗證身份）'),
});
